import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { PopupService } from '../../services/popup/popup.service';
import { NavigationService } from '../../services/navigation/navigation-onboarding.service';
import { CopyService } from '../../services/copies/copy.service';
import { FirmlyApprovedService } from '../../services/firmly-approved/firmly-approved.service';
import { OFFERS_STATUS_CONST } from '../../constants/offers-status.constants';
import { EVENT as EVENT_POPUP } from '../../constants/dali-popup.constants';
import { DaliService } from '@dali/tagger-ng8';
import { BitacoraService } from '../../services/bitacora/bitacora.service';
var PopupComponent = /** @class */ (function () {
    function PopupComponent(popupService, navigationService, firmlyApprovedService, copiesServices, daliService, bitacoraService) {
        this.popupService = popupService;
        this.navigationService = navigationService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.copiesServices = copiesServices;
        this.daliService = daliService;
        this.bitacoraService = bitacoraService;
        this.copies = this.copiesServices.copies.firmly_approved_popup;
    }
    PopupComponent.prototype.ngOnInit = function () {
        this.sendShowPopupEvent();
    };
    /**
     * Metodo que oculta el popup de la oferta de aprobados en firme.
     * @param continueFlow parametro que indica si se debe continuar el flujo.
     * @param isRedirecting parametro que indica si se debe redireccionar hacia la oferta de aprobados en firme.
     */
    PopupComponent.prototype.hidePopup = function (continueFlow, isRedirecting) {
        if (isRedirecting === void 0) { isRedirecting = false; }
        this.popupService.hidePopup(continueFlow, isRedirecting);
    };
    /**
     * Metodo que apaga la oferta de aprobados en firme cuando se presiona el boton de "No me interesa".
     */
    PopupComponent.prototype.turnOffFirmlyApprovedOffer = function () {
        this.sendNotInterestedPopupButtonEvent();
        this.hidePopup(true);
        var products = this.firmlyApprovedService.getProductsFirmlyApproved();
        var productsType = {
            freeInvestment: 'ORD',
            creditCard: 'TCR',
            revolvingCredit: 'CRP',
        };
        var product_code = '';
        products.forEach(function (product) {
            product_code = "" + product_code + productsType[product.product_type] + ",";
        });
        product_code = product_code.slice(0, product_code.length - 1);
        var product_list = [{
                product_code: product_code,
            }];
        this.bitacoraService.saveDataInBitacora('popup_af_rech');
        this.firmlyApprovedService.turnOffOffer(OFFERS_STATUS_CONST.REFUSE_ONBOARDING.CODE, product_list);
    };
    /**
     * Metodo encargado de redireccionar hacia la oferta de aprobados en firme.
     */
    PopupComponent.prototype.redirectToFirmlyApprovedOffer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.warn('call to method redirectToFirmlyApprovedOffer');
                        this.sendKnowMorePopupButtonEvent();
                        this.hidePopup(false, true);
                        this.bitacoraService.saveDataInBitacora('popup_af_avan');
                        this.popupService.continueWithFirmlyApproved = true;
                        return [4 /*yield*/, this.navigationService.nextStep('234')];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.warn('Error redirecting to firmlyApproved offers page:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /* ------------------ Taggeo ------------------ */
    PopupComponent.prototype.sendShowPopupEvent = function () {
        var event = {
            category: {
                module: EVENT_POPUP.customCategory.module.body,
                type: EVENT_POPUP.customCategory.type.content,
                position: EVENT_POPUP.customCategory.position.center,
            },
            action: EVENT_POPUP.customAction.show,
            label: EVENT_POPUP.pv10E9customLabel,
        };
        this.daliService.trackEvent(event);
    };
    PopupComponent.prototype.sendKnowMorePopupButtonEvent = function () {
        var event = {
            category: {
                module: EVENT_POPUP.customCategory.module.body,
                type: EVENT_POPUP.customCategory.type.button,
                position: EVENT_POPUP.customCategory.position.center,
            },
            action: EVENT_POPUP.customAction.click,
            label: EVENT_POPUP.pv10E10customLabel,
        };
        this.daliService.trackEvent(event);
    };
    PopupComponent.prototype.sendNotInterestedPopupButtonEvent = function () {
        var event = {
            category: {
                module: EVENT_POPUP.customCategory.module.body,
                type: EVENT_POPUP.customCategory.type.button,
                position: EVENT_POPUP.customCategory.position.center,
            },
            action: EVENT_POPUP.customAction.click,
            label: EVENT_POPUP.pv10E11customLabel,
        };
        this.daliService.trackEvent(event);
    };
    return PopupComponent;
}());
export { PopupComponent };
